import React, {useEffect, useState} from 'react';
import {css, styled} from 'styled-components';
import {colors} from '../../styles/colors';
import DefaultImageView from 'components/common/DefaultImageView';
import ScreenLayout from 'components/common/ScreenLayout';
import {getDevice} from 'utils/getDevice';
import DefaultText from 'components/common/DefaultText';
import {useRecoilValue} from 'recoil';
import {useNavigate} from 'react-router-dom';
import ContainerHeader from 'components/common/ContainerHeader';
import {minmax} from 'utils/minmax';
import DefaultInput from 'components/common/DefaultInput';
import Footer from 'components/common/Footer';
import WorkerList from 'components/userMenagement/WorkerList';
import {searchUser} from 'function/api';
import {userInfoState} from 'utils/Atoms';
import {
  IWorkerTongPlacePermissionProfile,
  ResponseSearchUser,
} from 'interfaces/interface';

/**
 * 사용자 관리 페이지 컴포넌트
 * 사용자 목록을 조회하고 관리하는 페이지입니다.
 * @returns {JSX.Element} 사용자 관리 페이지 컴포넌트
 */
const UserManagementUser = () => {
  const navigate = useNavigate();
  const device = getDevice();

  const userInfo = useRecoilValue(userInfoState);

  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});

  const [data, setData] = useState<any>(null);

  const [currentPage, setCurrentPage] = useState(1);

  const [keyword, setKeyword] = useState('');

  /**
   * 사용자 목록을 조회합니다.
   * 키워드를 기반으로 사용자 목록을 검색합니다.
   * @returns {Promise<void>}
   */
  const getUserList = async () => {
    // TODO: 근로자 목록 가져오기
    const result = await searchUser({
      userInfo,
      setIsLoading,
      setErrorModal,
      keyword,
      count: 10,
      page: currentPage,
    });
    result &&
      setData({
        tongPlacePermissionProfile: result.userProfiles,
        count: result.totalCount,
      });
  };

  useEffect(() => {
    getUserList();
  }, [currentPage]);

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      {/* <ServicePreparingInnerModal /> */}
      <Container>
        <ContainerHeader
          mainTitle="userManagement"
          subTitle="userManagementUser"
        />

        <Inner $device={device} style={{paddingTop: minmax(20)}}>
          <Header>
            <DefaultText
              text="사용자 목록"
              textStyle={{
                fontSize: minmax(30),
                fontWeight: 'bold',
                borderBottom: `3px solid ${colors.primary}`,
                width: 'fit-content',
                marginBottom: minmax(20),
              }}
            />
          </Header>

          <SearchArea>
            <InputWrap>
              <DefaultInput
                value={keyword}
                setValue={(e: any) => setKeyword(e)}
                placeholderText="workerListSearchPlaceholder"
                wrapperStyle={{height: '100%'}}
                onKeyPress={(e: any) => {
                  if (e.key === 'Enter') {
                    getUserList();
                  }
                }}
              />
              <DefaultImageView
                source="images/common/search.png"
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  height: '100%',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  getUserList();
                }}
              />
            </InputWrap>
          </SearchArea>

          <WorkerList
            data={data}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onClickWorker={worker =>
              navigate('/userManagementUserDetail', {
                state: {uuid: worker.owner.uuid, info: worker},
              })
            }
          />
        </Inner>
      </Container>
      <Footer isMain />
    </ScreenLayout>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  margin-bottom: ${minmax(120)};
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  column-gap: ${minmax(27)};
`;

const Inner = styled.div<{$device?: string}>`
  width: 90%;
  padding-bottom: max(12px, min(1.5vw, 24px));
  padding-left: 2%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props: any) =>
    props.$device !== 'pc' &&
    css`
      width: 100%;
    `}
`;

const SearchArea = styled.div`
  width: 100%;
  height: ${minmax(60)};
  margin-top: ${minmax(20)};
  display: flex;
  flex-direction: row;
  column-gap: 2%;
`;

const InputWrap = styled.div`
  width: 100%;
  position: relative;
`;

export default UserManagementUser;
